import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import BulkPurchaseOrderForm from "@/components/inventory/purchase-orders/BulkPurchaseOrderForm";
import { useAppSelector } from "@/redux/features/hooks";
import { usePermissions } from "@/hooks/usePermissions";
import { canRecordPurchaseOrders } from "@/lib/permissions";

const PurchaseOrderNewPage = () => {
  const restaurant = useAppSelector((state) => state.user.currentRestaurant);
  // The API guards purchase orders with PERMISSION_SUPPLIERS: saving needs
  // suppliers.manage (a typed URL must not lead to a 403 on save), and the
  // ingredient picker needs inventory.view (SFRESTO-165).
  const { can } = usePermissions();
  const canRecordPurchases = canRecordPurchaseOrders(can);
  if (!restaurant) return null;
  return (
    <div className="space-y-4">
      <Link
        to="/inventory/purchase-orders"
        className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-card-foreground"
      >
        <ArrowLeft className="h-4 w-4" />
        Retour aux bons de commande
      </Link>
      <div>
        <h1 className="text-lg font-semibold text-card-foreground">
          Saisie des achats
        </h1>
        <p className="text-sm text-muted-foreground">
          Enregistrez les achats effectués au marché, fournisseur par
          fournisseur.
        </p>
      </div>
      {canRecordPurchases ? (
        <BulkPurchaseOrderForm restaurantId={restaurant.id} />
      ) : (
        <p className="rounded-lg border border-border bg-card p-4 text-sm text-muted-foreground">
          Vous n'avez pas l'autorisation d'enregistrer des achats.
        </p>
      )}
    </div>
  );
};

export default PurchaseOrderNewPage;
